import type { Ref } from 'react';

export function combineRefs<T>(refs: Ref<T>[]) {
	return (thisRef: T) => {
		refs.forEach((ref) => {
			if (!ref) {
				return;
			}

			if (typeof ref === 'function') {
				ref(thisRef);
			} else {
				// @ts-expect-error: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065
				ref.current = thisRef;
			}
		});
	};
}
